export default "__VITE_ASSET__zBOWfszw__"